var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User / User_Square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.75 15.75C12.75 13.6789 11.0711 12 9 12C6.92893 12 5.25 13.6789 5.25 15.75M12.75 15.75H13.3523C14.1908 15.75 14.61 15.75 14.9305 15.5867C15.2128 15.4429 15.4429 15.2128 15.5867 14.9305C15.75 14.61 15.75 14.1908 15.75 13.3523V4.64768C15.75 3.80925 15.75 3.3894 15.5867 3.06885C15.4429 2.7866 15.2128 2.5573 14.9305 2.41349C14.6097 2.25 14.1902 2.25 13.3501 2.25H4.65015C3.81007 2.25 3.38972 2.25 3.06885 2.41349C2.7866 2.5573 2.5573 2.7866 2.41349 3.06885C2.25 3.38972 2.25 3.81007 2.25 4.65015V13.3501C2.25 14.1902 2.25 14.6097 2.41349 14.9305C2.5573 15.2128 2.7866 15.4429 3.06885 15.5867C3.3894 15.75 3.80925 15.75 4.64768 15.75H5.25M12.75 15.75H5.25M9 9.75C7.75736 9.75 6.75 8.74264 6.75 7.5C6.75 6.25736 7.75736 5.25 9 5.25C10.2426 5.25 11.25 6.25736 11.25 7.5C11.25 8.74264 10.2426 9.75 9 9.75Z",
    stroke: "#726C6C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSquare);
export default __webpack_public_path__ + "static/media/User_Square.fae2ccf8b56f699456bdcc73785bddf6.svg";
export { ForwardRef as ReactComponent };